import type { ReallocationBatchKey } from '../../types/response';

export type WizardStepKey = 'select' | 'configure' | 'review';

/** A single reassignment row within a batch (wizard-local, pre-commit). */
export interface ReassignmentRowState {
  id: string;
  fromAnnotatorId: string;
  toAnnotatorId: string;
  /** null while the field is empty. */
  count: number | null;
  /** Movable cap for this (from → to) pair, fetched on demand. null = unknown. */
  movable: number | null;
}

/** A computed preview-table row for one annotator within a batch. */
export interface PreviewRow {
  annotatorId: string;
  annotatorName: string;
  isAiAgent: boolean;
  pendingBefore: number;
  deltaPending: number;
  pendingAfter: number;
  draftCount: number;
  finalisedCount: number;
  totalBefore: number;
  totalAfter: number;
}

/** Batch render order within the wizard (Training → Validation → Test). */
export const WIZARD_BATCH_ORDER: ReallocationBatchKey[] = ['training', 'validation', 'test'];

export const WIZARD_STEPS: { key: WizardStepKey; labelId: string }[] = [
  { key: 'select', labelId: 'adminProjects.reallocation.step.selectBatch' },
  { key: 'configure', labelId: 'adminProjects.reallocation.step.configure' },
  { key: 'review', labelId: 'adminProjects.reallocation.step.review' },
];

export const BATCH_LABEL_IDS: Record<ReallocationBatchKey, string> = {
  training: 'adminProjects.reallocation.batch.training',
  validation: 'adminProjects.reallocation.batch.validation',
  test: 'adminProjects.reallocation.batch.test',
};
